var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleChoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.997802 10.9858C0.997802 12.6428 2.3408 13.9858 3.9978 13.9858C5.2658 13.9858 6.41382 13.1758 6.82782 11.9818L7.9978 11.9858L7.9978 17.9858C7.9978 18.5378 8.4458 18.9858 8.9978 18.9858L11.1778 18.9788C11.6508 20.2398 12.7298 20.9858 13.9978 20.9858C15.6548 20.9858 16.9978 19.6428 16.9978 17.9858C16.9978 16.3288 15.6548 14.9858 13.9978 14.9858C12.7298 14.9858 11.6068 15.8168 11.1718 16.9928L9.9978 16.9858L9.9978 11.9858L11.1718 11.9888C11.5808 13.1648 12.7298 13.9858 13.9978 13.9858C15.6548 13.9858 16.9978 12.6428 16.9978 10.9858C16.9978 9.32884 15.6548 7.98584 13.9978 7.98584C12.7298 7.98584 11.6218 8.77984 11.1778 9.98184L9.9978 9.98584L9.9978 4.98584L11.1758 4.98885C11.6148 6.15284 12.7298 6.98584 13.9978 6.98584C15.6548 6.98584 16.9978 5.64284 16.9978 3.98584C16.9978 2.32884 15.6548 0.985839 13.9978 0.985839C12.7298 0.985839 11.5718 1.80284 11.1548 2.99684L8.9978 2.98584C8.4458 2.98584 7.9978 3.43384 7.9978 3.98584L7.9978 9.98584L6.81482 9.98384C6.45282 8.85384 5.2658 7.98584 3.9978 7.98584C2.3408 7.98584 0.997802 9.32884 0.997802 10.9858Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleChoiceIcon);
export default __webpack_public_path__ + "static/media/multiple_choice_icon.72d64f6e.svg";
export { ForwardRef as ReactComponent };